import { ProfileSheet } from "@/components/shell/ProfileSheet";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * La MISMA ventana de perfil que ven admin y manager, con los dos destinos que
 * cambian en este portal:
 *  - el engranaje va a `/perito/perfil` (el perito no tiene Ajustes),
 *  - «Ver todas» va a la lista de notificaciones del perito.
 *
 * Es un envoltorio de tres líneas a propósito: así el diseño —foto, nombre,
 * rol · empresa, notificaciones recientes y Cerrar Sesión— se hereda entero y no
 * puede volver a separarse del de admin.
 */
export function PeritoProfileSheet({ open, onOpenChange }: Props) {
  return (
    <ProfileSheet
      open={open}
      onOpenChange={onOpenChange}
      settingsTo="/perito/perfil"
      notificationsTo="/perito/notificaciones"
    />
  );
}
